import React from "react";
import ProjectList from "../../newComponents/projectList";

const relatedProjects = ({ block }) => (
  <section>
    <div className="shell">
      {block.headline ?
        <header className="section__head mb-8 mt-4">
          <p className="section__title title h2 text-gray">{block.headline}</p>
        </header>
        :
        <></>
      }
      <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
        <ul>
          <ProjectList projects={block.project} keyBase="related-projects"/>
        </ul>
        <div className="swiper-pagination boxes__pagination" />
      </div>
    </div>
  </section>
);

export default relatedProjects;